import React, { createContext, useContext, useState, useEffect } from 'react';
import { initialProducts, initialWarehouses } from '../data/mockData';

const InventoryContext = createContext();

export const InventoryProvider = ({ children }) => {
  const [systemName, setSystemName] = useState(() => localStorage.getItem('pvc_sysName') || 'نظام إدارة الإنتاج والمخازن');
  const [products, setProducts] = useState(() => { const s = localStorage.getItem('pvc_products'); return s ? JSON.parse(s) : initialProducts; });
  const [warehouses, setWarehouses] = useState(() => { const s = localStorage.getItem('pvc_warehouses'); return s ? JSON.parse(s) : initialWarehouses; });
  const [transactions, setTransactions] = useState(() => { const s = localStorage.getItem('pvc_transactions'); return s ? JSON.parse(s) : []; });

  useEffect(() => {
    localStorage.setItem('pvc_sysName', systemName);
    localStorage.setItem('pvc_products', JSON.stringify(products));
    localStorage.setItem('pvc_warehouses', JSON.stringify(warehouses));
    localStorage.setItem('pvc_transactions', JSON.stringify(transactions));
  }, [systemName, products, warehouses, transactions]);

  const addTransaction = (t) => {
    const voucherId = transactions.length > 0 ? Math.max(...transactions.map(tr => tr.voucherId || 0)) + 1 : 1000;
    const newT = { ...t, id: Date.now(), voucherId };
    setTransactions([newT, ...transactions]);
  };

  const editTransaction = (updatedT) => {
    setTransactions(transactions.map(t => t.id === updatedT.id ? updatedT : t));
  };

  const deleteTransaction = (id) => setTransactions(transactions.filter(t => t.id !== id));
  const editProduct = (updatedP) => setProducts(products.map(p => p.id === updatedP.id ? updatedP : p));

  const resetToDemoData = () => {
    if(window.confirm("تحذير: سيتم مسح جميع البيانات الحالية! هل أنت متأكد؟")) {
      setProducts(initialProducts); setWarehouses(initialWarehouses); setTransactions([]);
    }
  };

  const getStockReport = (dateStr) => {
    const targetDate = new Date(dateStr); targetDate.setHours(23, 59, 59, 999);
    const report = {};
    
    products.forEach(p => {
      report[p.id] = { 
        ...p, 
        totalStock: p.openingStock || 0, 
        wipStock: 0, 
        breakdown: {}, 
        purchasesQty: 0,
        productionYieldQty: 0,
        returnsQty: 0,
        salesQty: 0,
        bomQty: 0 
      };
      warehouses.forEach(w => report[p.id].breakdown[w.id] = 0);
      if(p.openingStock > 0) report[p.id].breakdown["w1"] = p.openingStock;
    });

    const filtered = transactions.filter(t => new Date(t.date) <= targetDate);
    
    filtered.forEach(t => {
      if (t.type === 'supply') {
        report[t.productId].breakdown[t.warehouseId] += t.quantity;
        report[t.productId].purchasesQty += t.quantity;
      } else if (t.type === 'sales_return') {
        report[t.productId].breakdown[t.warehouseId] += t.quantity;
        report[t.productId].returnsQty += t.quantity;
      } else if (t.type === 'production') {
        report[t.productId].breakdown[t.warehouseId] += t.quantity;
        report[t.productId].productionYieldQty += t.quantity;
        t.bomItems?.forEach(item => {
          report[item.productId].breakdown[item.warehouseId] -= item.quantity;
          report[item.productId].bomQty += item.quantity;
        });
      } else if (t.type === 'sales') {
        report[t.productId].breakdown[t.warehouseId] -= t.quantity;
        report[t.productId].salesQty += t.quantity;
      } else if (t.type === 'transfer') {
        report[t.productId].breakdown[t.fromWarehouseId] -= t.quantity;
        report[t.productId].breakdown[t.toWarehouseId] += t.quantity;
      }
    });

    Object.keys(report).forEach(pid => {
      const p = report[pid];
      p.totalStock = Object.values(p.breakdown).reduce((a, b) => a + b, 0);
      p.wipStock = p.breakdown["w2"] || 0;
    });
    return Object.values(report);
  };

  return (
    <InventoryContext.Provider value={{ 
      systemName, setSystemName, products, setProducts, editProduct, warehouses, setWarehouses, 
      transactions, addTransaction, editTransaction, deleteTransaction, getStockReport, resetToDemoData
    }}>
      {children}
    </InventoryContext.Provider>
  );
};
export const useInventory = () => useContext(InventoryContext);
